import { ModifiersZTableModel } from '../../table.modifier';
import { TTableCellTree, TTableOptions, TTableRowNode } from '../../table.type';

type TChatbotTableModelData = Array<Partial<Record<string, string | number>>>;
type TChatbotTableModelHeaders = string[];

const COLUMN_WIDTH_PX = 150;
const EMPTY_CELL_TEXT = '- -';

export const CHATBOT_TABLE_MODEL = {
  createModel: function (headerInfo: TChatbotTableModelHeaders, data: TChatbotTableModelData) {
    const headers = headerInfo?.length ? headerInfo : Object.keys(data[0] ?? {});

    return ModifiersZTableModel.createTableModel(
      data,
      {
        headerConfig: getHeaderConfig(headers),
      },
      (el: TChatbotTableModelData[number]): TTableRowNode<TChatbotTableModelData[number]> => {
        return {
          type: 'ROW',
          rowItem: el,
          cells: getRowCells(headers, el),
        };
      },
    );
  },
};

function getHeaderConfig(headerInfo: TChatbotTableModelHeaders): TTableOptions['headerConfig'] {
  return headerInfo.map<TTableOptions['headerConfig'][number]>((header) => ({
    type: 'TEXT_CELL',
    text: header,
    widthInPx: COLUMN_WIDTH_PX,
  }));
}

function getRowCells(headerInfo: TChatbotTableModelHeaders, rowItem: TChatbotTableModelData[number]): TTableCellTree[] {
  return headerInfo.map<TTableCellTree>((header) => ({
    type: 'TEXT_CELL',
    // A query result can omit a column for a row, so the cell falls back to a placeholder.
    text: rowItem[header] ?? EMPTY_CELL_TEXT,
    widthInPx: COLUMN_WIDTH_PX,
  }));
}
